(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~tabs"],{

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "TabPane", function() { return /* reexport */ TabPane; });
__webpack_require__.d(__webpack_exports__, "TabContent", function() { return /* reexport */ TabContent; });

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./node_modules/vue-ref/index.js
var vue_ref = __webpack_require__(24);
var vue_ref_default = /*#__PURE__*/__webpack_require__.n(vue_ref);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(10);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: ./node_modules/omit.js/es/index.js
var es = __webpack_require__(13);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/raf/index.js
var raf = __webpack_require__(14);
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: ./src/base/vc-tabs/src/KeyCode.js
/* harmony default export */ var KeyCode = ({
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST

  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH

  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST

  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH

});
// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// EXTERNAL MODULE: ./src/utils/key_code.js
var key_code = __webpack_require__(9);

// CONCATENATED MODULE: ./src/base/vc-tabs/src/Sentinel.jsx



var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: 'hidden',
  position: 'absolute'
};
/* harmony default export */ var Sentinel = ({
  name: 'Sentinel',
  props: {
    setRef: vue_types["a" /* default */].func,
    prevElement: vue_types["a" /* default */].any,
    nextElement: vue_types["a" /* default */].any
  },
  methods: {
    onKeyDown: function onKeyDown(_ref) {
      var target = _ref.target,
          which = _ref.which,
          shiftKey = _ref.shiftKey;
      var _this$$props = this.$props,
          nextElement = _this$$props.nextElement,
          prevElement = _this$$props.prevElement;
      if (which !== key_code["a" /* default */].TAB || document.activeElement !== target) return; // Tab next

      if (!shiftKey && nextElement) {
        nextElement.focus();
      } // Tab prev


      if (shiftKey && prevElement) {
        prevElement.focus();
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var setRef = this.$props.setRef;
    return h("div", babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        tabIndex: 0
      }
    }, {
      directives: [{
        name: 'meg-ref',
        value: setRef
      }]
    }, {
      style: sentinelStyle,
      on: {
        "keydown": this.onKeyDown
      },
      attrs: {
        role: "presentation"
      }
    }]), [this.$slots.default]);
  }
});
// EXTERNAL MODULE: ./src/utils/isvalid.js
var isvalid = __webpack_require__(64);

// CONCATENATED MODULE: ./src/base/vc-tabs/src/Tabs.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable vue/no-reserved-keys */










function getDefaultActiveKey(props) {
  var activeKey;
  var children = props.children;
  children.forEach(function (child) {
    if (child && !Object(isvalid["a" /* default */])(activeKey) && !child.disabled) {
      activeKey = child.key;
    }
  });
  return activeKey;
}

function activeKeyIsValid(props, key) {
  var children = props.children;
  var keys = children.map(function (child) {
    return child && child.key;
  });
  return keys.indexOf(key) >= 0;
}

/* harmony default export */ var Tabs = ({
  name: "Tabs",
  mixins: [BaseMixin["a" /* default */]],
  model: {
    prop: "activeKey",
    event: "change"
  },
  props: {
    destroyInactiveTabPane: vue_types["a" /* default */].bool,
    renderTabBar: vue_types["a" /* default */].func.isRequired,
    renderTabContent: vue_types["a" /* default */].func.isRequired,
    navWrapper: vue_types["a" /* default */].func.def(function (arg) {
      return arg;
    }),
    children: vue_types["a" /* default */].any.def([]),
    prefixCls: vue_types["a" /* default */].string.def("ant-tabs"),
    tabBarPosition: vue_types["a" /* default */].string.def("top"),
    activeKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    defaultActiveKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    __propsSymbol__: vue_types["a" /* default */].any,
    direction: vue_types["a" /* default */].string.def("ltr"),
    tabBarGutter: vue_types["a" /* default */].number
  },
  data: function data() {
    var props = Object(props_util["getOptionProps"])(this);
    var activeKey;

    if ("activeKey" in props) {
      activeKey = props.activeKey;
    } else if ("defaultActiveKey" in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = getDefaultActiveKey(props);
    }

    return {
      _activeKey: activeKey
    };
  },
  provide: function provide() {
    return {
      sentinelContext: this
    };
  },
  watch: {
    __propsSymbol__: function __propsSymbol__() {
      var nextProps = Object(props_util["getOptionProps"])(this);

      if ("activeKey" in nextProps) {
        this.setState({
          _activeKey: nextProps.activeKey
        });
      } else if (!activeKeyIsValid(nextProps, this.$data._activeKey)) {
        // https://github.com/ant-design/ant-design/issues/7093
        this.setState({
          _activeKey: getDefaultActiveKey(nextProps)
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy = true;
    raf_default.a.cancel(this.sentinelId);
  },
  methods: {
    onTabClick: function onTabClick(activeKey, e) {
      if (this.tabBar.componentOptions && this.tabBar.componentOptions.listeners && this.tabBar.componentOptions.listeners.tabClick) {
        this.tabBar.componentOptions.listeners.tabClick(activeKey, e);
      }

      this.setActiveKey(activeKey);
    },
    onNavKeyDown: function onNavKeyDown(e) {
      var eventKeyCode = e.keyCode;

      if (eventKeyCode === KeyCode.RIGHT || eventKeyCode === KeyCode.DOWN) {
        e.preventDefault();
        var nextKey = this.getNextActiveKey(true);
        this.onTabClick(nextKey);
      } else if (eventKeyCode === KeyCode.LEFT || eventKeyCode === KeyCode.UP) {
        e.preventDefault();
        var previousKey = this.getNextActiveKey(false);
        this.onTabClick(previousKey);
      }
    },
    onScroll: function onScroll(_ref) {
      var target = _ref.target,
          currentTarget = _ref.currentTarget;

      if (target === currentTarget && target.scrollLeft > 0) {
        target.scrollLeft = 0;
      }
    },
    // Sentinel for tab index
    setSentinelStart: function setSentinelStart(node) {
      this.sentinelStart = node;
    },
    setSentinelEnd: function setSentinelEnd(node) {
      this.sentinelEnd = node;
    },
    setPanelSentinelStart: function setPanelSentinelStart(node) {
      if (node !== this.panelSentinelStart) {
        this.updateSentinelContext();
      }

      this.panelSentinelStart = node;
    },
    setPanelSentinelEnd: function setPanelSentinelEnd(node) {
      if (node !== this.panelSentinelEnd) {
        this.updateSentinelContext();
      }

      this.panelSentinelEnd = node;
    },
    setActiveKey: function setActiveKey(activeKey) {
      if (this.$data._activeKey !== activeKey) {
        var props = Object(props_util["getOptionProps"])(this);

        if (!("activeKey" in props)) {
          this.setState({
            _activeKey: activeKey
          });
        }

        this.__emit("change", activeKey);
      }
    },
    getNextActiveKey: function getNextActiveKey(next) {
      var activeKey = this.$data._activeKey;
      var children = [];
      this.$props.children.forEach(function (c) {
        if (c && !c.disabled && c.disabled !== "") {
          if (next) {
            children.push(c);
          } else {
            children.unshift(c);
          }
        }
      });
      var length = children.length;
      var ret = length && children[0].key;
      children.forEach(function (child, i) {
        if (child.key === activeKey) {
          if (i === length - 1) {
            ret = children[0].key;
          } else {
            ret = children[i + 1].key;
          }
        }
      });
      return ret;
    },
    updateSentinelContext: function updateSentinelContext() {
      var _this = this;

      if (this.destroy) return;
      raf_default.a.cancel(this.sentinelId);
      this.sentinelId = raf_default()(function () {
        if (_this.destroy) return;

        _this.$forceUpdate();
      });
    }
  },
  render: function render() {
    var _cls;

    var h = arguments[0];
    var props = this.$props;
    var prefixCls = props.prefixCls,
        navWrapper = props.navWrapper,
        tabBarPosition = props.tabBarPosition,
        renderTabContent = props.renderTabContent,
        renderTabBar = props.renderTabBar,
        destroyInactiveTabPane = props.destroyInactiveTabPane,
        direction = props.direction,
        tabBarGutter = props.tabBarGutter;
    var cls = (_cls = {}, _defineProperty(_cls, prefixCls, 1), _defineProperty(_cls, "".concat(prefixCls, "-").concat(tabBarPosition), 1), _defineProperty(_cls, "".concat(prefixCls, "-rtl"), direction === "rtl"), _cls);
    this.tabBar = renderTabBar();
    var tabBar = Object(vnode["a" /* cloneElement */])(this.tabBar, {
      props: {
        prefixCls: prefixCls,
        navWrapper: navWrapper,
        tabBarPosition: tabBarPosition,
        panels: props.children,
        activeKey: this.$data._activeKey,
        direction: direction,
        tabBarGutter: tabBarGutter
      },
      on: {
        keydown: this.onNavKeyDown,
        tabClick: this.onTabClick
      },
      key: "tabBar"
    });
    var tabContent = Object(vnode["a" /* cloneElement */])(renderTabContent(), {
      props: {
        prefixCls: prefixCls,
        tabBarPosition: tabBarPosition,
        activeKey: this.$data._activeKey,
        destroyInactiveTabPane: destroyInactiveTabPane,
        direction: direction
      },
      on: {
        change: this.setActiveKey
      },
      children: props.children,
      key: "tabContent"
    });
    var sentinelStart = h(Sentinel, {
      key: "sentinelStart",
      attrs: {
        setRef: this.setSentinelStart,
        nextElement: this.panelSentinelStart
      }
    });
    var sentinelEnd = h(Sentinel, {
      key: "sentinelEnd",
      attrs: {
        setRef: this.setSentinelEnd,
        prevElement: this.panelSentinelEnd
      }
    });
    var contents = [];

    if (tabBarPosition === "bottom") {
      contents.push(sentinelStart, tabContent, sentinelEnd, tabBar);
    } else {
      contents.push(tabBar, sentinelStart, tabContent, sentinelEnd);
    }

    var listeners = _objectSpread(_objectSpread({}, Object(es["a" /* default */])(Object(props_util["getListeners"])(this), ["change"])), {}, {
      scroll: this.onScroll
    });

    return h("div", {
      on: listeners,
      class: cls
    }, [contents]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-tabs/src/TabPane.jsx
function TabPane_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ var TabPane = ({
  name: 'TabPane',
  props: {
    active: vue_types["a" /* default */].bool,
    destroyInactiveTabPane: vue_types["a" /* default */].bool,
    forceRender: vue_types["a" /* default */].bool,
    placeholder: vue_types["a" /* default */].any,
    rootPrefixCls: vue_types["a" /* default */].string,
    tab: vue_types["a" /* default */].any,
    closable: vue_types["a" /* default */].bool,
    disabled: vue_types["a" /* default */].bool
  },
  inject: {
    sentinelContext: {
      default: function _default() {
        return {};
      }
    }
  },
  render: function render() {
    var _cls;

    var h = arguments[0];
    var _this$$props = this.$props,
        destroyInactiveTabPane = _this$$props.destroyInactiveTabPane,
        active = _this$$props.active,
        forceRender = _this$$props.forceRender,
        rootPrefixCls = _this$$props.rootPrefixCls;
    var children = this.$slots.default;
    var placeholder = Object(props_util["getComponentFromProp"])(this, 'placeholder');
    this.isActived = this.isActived || active;
    var prefixCls = "".concat(rootPrefixCls, "-tabpane");
    var cls = (_cls = {}, TabPane_defineProperty(_cls, prefixCls, 1), TabPane_defineProperty(_cls, "".concat(prefixCls, "-inactive"), !active), TabPane_defineProperty(_cls, "".concat(prefixCls, "-active"), active), _cls);
    var isRender = destroyInactiveTabPane ? active : this.isActived;
    var shouldRender = isRender || forceRender;
    var _this$sentinelContext = this.sentinelContext,
        sentinelStart = _this$sentinelContext.sentinelStart,
        sentinelEnd = _this$sentinelContext.sentinelEnd,
        setPanelSentinelStart = _this$sentinelContext.setPanelSentinelStart,
        setPanelSentinelEnd = _this$sentinelContext.setPanelSentinelEnd;
    var panelSentinelStart;
    var panelSentinelEnd;

    if (active && shouldRender) {
      panelSentinelStart = h(Sentinel, {
        attrs: {
          setRef: setPanelSentinelStart,
          prevElement: sentinelStart
        }
      });
      panelSentinelEnd = h(Sentinel, {
        attrs: {
          setRef: setPanelSentinelEnd,
          nextElement: sentinelEnd
        }
      });
    }

    return h("div", {
      "class": cls,
      attrs: {
        role: "tabpanel",
        "aria-hidden": active ? 'false' : 'true'
      }
    }, [panelSentinelStart, shouldRender ? children : placeholder, panelSentinelEnd]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-tabs/src/utils.js
function utils_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function toArray(children) {
  var c = [];
  children.forEach(function (child) {
    if (child.data) {
      c.push(child);
    }
  });
  return c;
}
function getActiveIndex(children, activeKey) {
  var c = toArray(children);

  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }

  return -1;
}
function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}
function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}
function isTransform3dSupported(style) {
  return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
}
function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}
function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}
function utils_isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}
function getTransformByIndex(index, tabBarPosition) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ltr';
  var translate = utils_isVertical(tabBarPosition) ? 'translateY' : 'translateX';

  if (!utils_isVertical(tabBarPosition) && direction === 'rtl') {
    return "".concat(translate, "(").concat(index * 100, "%) translateZ(0)");
  }

  return "".concat(translate, "(").concat(-index * 100, "%) translateZ(0)");
}
function getMarginStyle(index, tabBarPosition) {
  var marginDirection = utils_isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return utils_defineProperty({}, marginDirection, "".concat(-index * 100, "%"));
}
function getStyle(el, property) {
  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}
function setPxStyle(el, value, vertical) {
  value = vertical ? "0px, ".concat(value, "px, 0px") : "".concat(value, "px, 0px, 0px");
  setTransform(el.style, "translate3d(".concat(value, ")"));
}
function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}

function toNum(style, property) {
  return +style.getPropertyValue(property).replace('px', '');
}

function getTypeValue(start, current, end, tabNode, wrapperNode) {
  var total = getStyle(wrapperNode, "padding-".concat(start));

  if (!tabNode || !tabNode.parentNode) {
    return total;
  }

  var childNodes = tabNode.parentNode.childNodes;
  Array.prototype.some.call(childNodes, function (node) {
    var style = window.getComputedStyle(node);

    if (node !== tabNode) {
      total += toNum(style, "margin-".concat(start));
      total += node[current];
      total += toNum(style, "margin-".concat(end));

      if (style.boxSizing === 'content-box') {
        total += toNum(style, "border-".concat(start, "-width")) + toNum(style, "border-".concat(end, "-width"));
      }

      return false;
    } // We need count current node margin
    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262


    total += toNum(style, "margin-".concat(start));
    return true;
  });
  return total;
}

function getLeft(tabNode, wrapperNode) {
  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}
function getTop(tabNode, wrapperNode) {
  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}
// CONCATENATED MODULE: ./src/base/vc-tabs/src/TabContent.jsx
function TabContent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ var TabContent = ({
  name: 'TabContent',
  props: {
    animated: {
      type: Boolean,
      default: true
    },
    animatedWithMargin: {
      type: Boolean,
      default: true
    },
    prefixCls: {
      default: 'ant-tabs',
      type: String
    },
    activeKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    tabBarPosition: String,
    direction: vue_types["a" /* default */].string,
    destroyInactiveTabPane: vue_types["a" /* default */].bool
  },
  computed: {
    classes: function classes() {
      var _ref;

      var animated = this.animated,
          prefixCls = this.prefixCls;
      return _ref = {}, TabContent_defineProperty(_ref, "".concat(prefixCls, "-content"), true), TabContent_defineProperty(_ref, animated ? "".concat(prefixCls, "-content-animated") : "".concat(prefixCls, "-content-no-animated"), true), _ref;
    }
  },
  methods: {
    getTabPanes: function getTabPanes() {
      var props = this.$props;
      var activeKey = props.activeKey;
      var children = this.$slots.default || [];
      var newChildren = [];
      children.forEach(function (child) {
        if (!child) {
          return;
        }

        var key = child.key;
        var active = activeKey === key;
        newChildren.push(Object(vnode["a" /* cloneElement */])(child, {
          props: {
            active: active,
            destroyInactiveTabPane: props.destroyInactiveTabPane,
            rootPrefixCls: props.prefixCls
          }
        }));
      });
      return newChildren;
    }
  },
  render: function render() {
    var h = arguments[0];
    var activeKey = this.activeKey,
        tabBarPosition = this.tabBarPosition,
        animated = this.animated,
        animatedWithMargin = this.animatedWithMargin,
        direction = this.direction,
        classes = this.classes;
    var style = {};

    if (animated && this.$slots.default) {
      var activeIndex = getActiveIndex(this.$slots.default, activeKey);

      if (activeIndex !== -1) {
        var animatedStyle = animatedWithMargin ? getMarginStyle(activeIndex, tabBarPosition) : getTransformPropValue(getTransformByIndex(activeIndex, tabBarPosition, direction));
        style = animatedStyle;
      } else {
        style = {
          display: 'none'
        };
      }
    }

    return h("div", {
      "class": classes,
      style: style
    }, [this.getTabPanes()]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-tabs/src/index.js
// based on rc-tabs 9.7.0





external_vue_default.a.use(vue_ref_default.a, {
  name: 'meg-ref'
});
/* harmony default export */ var src = (Tabs);

// CONCATENATED MODULE: ./src/utils/style_checker.js
var isStyleSupport = function isStyleSupport(styleName) {
  if (typeof window !== "undefined" && window.document && window.document.documentElement) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function (name) {
      return name in documentElement.style;
    });
  }

  return false;
};

var isFlexSupported = isStyleSupport(["flex", "webkitFlex", "Flex", "msFlex"]);
/* harmony default export */ var style_checker = (isStyleSupport);
// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// CONCATENATED MODULE: ./src/base/vc-tabs/src/InkTabBarNode.jsx


function InkTabBarNode_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function componentDidUpdate(component, init) {
  var _component$$props = component.$props,
      _component$$props$sty = _component$$props.styles,
      styles = _component$$props$sty === void 0 ? {} : _component$$props$sty,
      panels = _component$$props.panels,
      activeKey = _component$$props.activeKey,
      direction = _component$$props.direction;
  var rootNode = component.getRef('root');
  var wrapNode = component.getRef('nav') || rootNode;
  var inkBarNode = component.getRef('inkBar');
  var activeTab = component.getRef('activeTab');
  var inkBarNodeStyle = inkBarNode.style;
  var tabBarPosition = component.$props.tabBarPosition;
  var activeIndex = getActiveIndex(panels, activeKey);

  if (init) {
    // prevent mount animation
    inkBarNodeStyle.display = 'none';
  }

  if (activeTab) {
    var tabNode = activeTab;
    var transformSupported = isTransform3dSupported(inkBarNodeStyle); // Reset current style

    setTransform(inkBarNodeStyle, '');
    inkBarNodeStyle.width = '';
    inkBarNodeStyle.height = '';
    inkBarNodeStyle.left = '';
    inkBarNodeStyle.top = '';
    inkBarNodeStyle.bottom = '';
    inkBarNodeStyle.right = '';

    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
      var left = getLeft(tabNode, wrapNode);
      var width = tabNode.offsetWidth; // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
      // It means no css working, then ink bar should not have width until css is loaded
      // Fix https://github.com/ant-design/ant-design/issues/7564

      if (width === rootNode.offsetWidth) {
        width = 0;
      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
        width = parseFloat(styles.inkBar.width, 10);

        if (width) {
          left += (tabNode.offsetWidth - width) / 2;
        }
      }

      if (direction === 'rtl') {
        left = getStyle(tabNode, 'margin-left') - left;
      } // use 3d gpu to optimize render


      if (transformSupported) {
        setTransform(inkBarNodeStyle, "translate3d(".concat(left, "px,0,0)"));
      } else {
        inkBarNodeStyle.left = "".concat(left, "px");
      }

      inkBarNodeStyle.width = "".concat(width, "px");
    } else {
      var top = getTop(tabNode, wrapNode, true);
      var height = tabNode.offsetHeight;

      if (styles.inkBar && styles.inkBar.height !== undefined) {
        height = parseFloat(styles.inkBar.height, 10);

        if (height) {
          top += (tabNode.offsetHeight - height) / 2;
        }
      }

      if (transformSupported) {
        setTransform(inkBarNodeStyle, "translate3d(0,".concat(top, "px,0)"));
        inkBarNodeStyle.top = '0';
      } else {
        inkBarNodeStyle.top = "".concat(top, "px");
      }

      inkBarNodeStyle.height = "".concat(height, "px");
    }
  }

  inkBarNodeStyle.display = activeIndex !== -1 ? 'block' : 'none';
}

/* harmony default export */ var InkTabBarNode = ({
  name: 'InkTabBarNode',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    inkBarAnimated: {
      type: Boolean,
      default: true
    },
    direction: vue_types["a" /* default */].string,
    prefixCls: String,
    styles: Object,
    tabBarPosition: String,
    saveRef: vue_types["a" /* default */].func.def(function () {}),
    getRef: vue_types["a" /* default */].func.def(function () {}),
    panels: vue_types["a" /* default */].array,
    activeKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])
  },
  updated: function updated() {
    this.$nextTick(function () {
      componentDidUpdate(this);
    });
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      componentDidUpdate(this, true);
    });
  },
  render: function render() {
    var _classes;

    var h = arguments[0];
    var prefixCls = this.prefixCls,
        _this$styles = this.styles,
        styles = _this$styles === void 0 ? {} : _this$styles,
        inkBarAnimated = this.inkBarAnimated;
    var className = "".concat(prefixCls, "-ink-bar");
    var classes = (_classes = {}, InkTabBarNode_defineProperty(_classes, className, true), InkTabBarNode_defineProperty(_classes, inkBarAnimated ? "".concat(className, "-animated") : "".concat(className, "-no-animated"), true), _classes);
    return h("div", babel_helper_vue_jsx_merge_props_default()([{
      style: styles.inkBar,
      "class": classes,
      key: "inkBar"
    }, {
      directives: [{
        name: 'meg-ref',
        value: this.saveRef('inkBar')
      }]
    }]));
  }
});
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(16);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);

// CONCATENATED MODULE: ./src/base/vc-tabs/src/TabBarTabsNode.jsx


function TabBarTabsNode_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function noop() {}

/* harmony default export */ var TabBarTabsNode = ({
  name: 'TabBarTabsNode',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    activeKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    panels: vue_types["a" /* default */].any.def([]),
    prefixCls: vue_types["a" /* default */].string.def(''),
    tabBarGutter: vue_types["a" /* default */].any.def(null),
    extraContent: vue_types["a" /* default */].any,
    onTabClick: vue_types["a" /* default */].func,
    saveRef: vue_types["a" /* default */].func.def(noop),
    getRef: vue_types["a" /* default */].func.def(noop),
    renderTabBarNode: vue_types["a" /* default */].func,
    tabBarPosition: vue_types["a" /* default */].string,
    direction: vue_types["a" /* default */].string
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var _this$$props = this.$props,
        children = _this$$props.panels,
        activeKey = _this$$props.activeKey,
        prefixCls = _this$$props.prefixCls,
        tabBarGutter = _this$$props.tabBarGutter,
        extraContent = _this$$props.extraContent,
        saveRef = _this$$props.saveRef,
        tabBarPosition = _this$$props.tabBarPosition,
        direction = _this$$props.direction;
    var rst = [];
    var renderTabBarNode = this.renderTabBarNode || this.$scopedSlots.renderTabBarNode;
    children.forEach(function (child, index) {
      if (!child) {
        return;
      }

      var props = Object(props_util["getOptionProps"])(child);
      var key = child.key;
      var cls = activeKey === key ? "".concat(prefixCls, "-tab-active") : '';
      cls += " ".concat(prefixCls, "-tab");
      var events = {
        on: {}
      };
      var disabled = props.disabled || props.disabled === '';

      if (disabled) {
        cls += " ".concat(prefixCls, "-tab-disabled");
      } else {
        events.on.click = function () {
          _this.__emit('tabClick', key);
        };
      }

      var directives = [];

      if (activeKey === key) {
        directives.push({
          name: 'meg-ref',
          value: saveRef('activeTab')
        });
      }

      var tab = Object(props_util["getComponentFromProp"])(child, 'tab');
      var gutter = tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter;
      gutter = typeof gutter === 'number' ? "".concat(gutter, "px") : gutter;
      var marginProperty = direction === 'rtl' ? 'marginLeft' : 'marginRight';

      var style = TabBarTabsNode_defineProperty({}, utils_isVertical(tabBarPosition) ? 'marginBottom' : marginProperty, gutter);

      warning_default()(tab !== undefined, 'There must be `tab` property or slot on children of Tabs.');
      var node = h("div", babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          role: "tab",
          "aria-disabled": disabled ? 'true' : 'false',
          "aria-selected": activeKey === key ? 'true' : 'false'
        }
      }, events, {
        "class": cls,
        key: key,
        style: style
      }, {
        directives: directives
      }]), [tab]);

      if (renderTabBarNode) {
        node = renderTabBarNode(node);
      }

      rst.push(node);
    }); //extra content class

    if (extraContent) {
      extraContent.data.class = "".concat(prefixCls, "-tab ").concat(extraContent.data.class);
    }

    return h("div", {
      directives: [{
        name: 'meg-ref',
        value: this.saveRef('navTabsContainer')
      }]
    }, [rst, extraContent]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-tabs/src/TabBarRootNode.jsx


function TabBarRootNode_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function TabBarRootNode_noop() {}

/* harmony default export */ var TabBarRootNode = ({
  name: 'TabBarRootNode',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    saveRef: vue_types["a" /* default */].func.def(TabBarRootNode_noop),
    getRef: vue_types["a" /* default */].func.def(TabBarRootNode_noop),
    prefixCls: vue_types["a" /* default */].string.def(''),
    tabBarPosition: vue_types["a" /* default */].string.def('top'),
    extraContent: vue_types["a" /* default */].any
  },
  methods: {
    onKeyDown: function onKeyDown(e) {
      this.__emit('keydown', e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        onKeyDown = this.onKeyDown,
        tabBarPosition = this.tabBarPosition,
        extraContent = this.extraContent;

    var cls = TabBarRootNode_defineProperty({}, "".concat(prefixCls, "-bar"), true);

    var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
    var tabBarExtraContentStyle = topOrBottom ? {
      float: 'right'
    } : {};
    var children = this.$slots.default;
    var newChildren = children;

    if (extraContent) {
      newChildren = [// 按照设计稿先隐藏右侧添加按钮  后续修复  根据是否出现滚动  判断是否显示
      // cloneElement(extraContent, {
      //   key: 'extra',
      //   style: {
      //     ...tabBarExtraContentStyle,
      //   },
      // }),
      Object(vnode["a" /* cloneElement */])(children, {
        key: 'content'
      })];
      newChildren = topOrBottom ? newChildren : newChildren.reverse();
    }

    return h("div", babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        role: "tablist",
        tabIndex: "0"
      },
      "class": cls,
      on: {
        "keydown": onKeyDown
      }
    }, {
      directives: [{
        name: 'meg-ref',
        value: this.saveRef('root')
      }]
    }]), [newChildren]);
  }
});
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(67);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(66);

// CONCATENATED MODULE: ./src/components/tabs/style/menuClose.png
/* harmony default export */ var menuClose = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABENJREFUWEfFV11oHFUU/s5kdpOiFUO1xDRRQkUiRWLIZu+5Ki2iFOoPtaClfVOUKj6o1D6I1fpbRSRS+yDEIoov9adoq1IL9qVRmLubzU8tah6swSaNwVgiFjGb7M6RG3bj7mYnM5sUvLCwzHznO98995xzzxD+50W1+k+n0xvy+fxGImoGYH92TYjIRF1dXV8ymfyhFs5IAoaGhq7MZrNPi8hOAOtDHJwlosP19fU9nZ2df4aJWVKAiDjGmKcAPAegMYys4v00gFeZ+QAR+UG2gQKMMVcAOCwid9XouAxORMcB7GTmv6rxVBWQyWSuyuVyfSJy40qcF22J6EfXdTclEok/KvkWCchkMrFcLndSRDZeCuclIvpc170zkUjMlfIuEmCMeVtEnriUzktEHGTmJwMFeJ5nQ34GQF3V8yJKicgNSyTkRQDfE9EtIlLtePMAbtJa/7QgqtSRMeaoiGwNcD7AzImBgYHr5+bmjIisKdsJ0d+O49yWTCaHjTHHRWRLAM8xZr5vkYBMJnNNLpc7H6Dc4qdjsdiGRCLxWzqd3uj7/jciErcvbJmJyDat9Re2Z8zMzAwDuC5AgLiuu87yzNsWQcaYXSLSG3L2/S0tLZtaW1v/8TzvQQDvFwTsYeYeEXGNMScA3LEUDxE9yszvVgr4XEQWQhPYOIiOKKW2E5EYY14HsIaZd1m8MaZXROb/hwg4yszbKgUMi0hHmHHh/Wta672F46ojopznebsB9ESxJ6LTzHxzmQDP834HcHUUggJmh9b648LONwP42rbuiPZTWuu1lQJmANRHISCiC7FYjLu6un62+MHBweZsNpsGsC6KPYCs1rqhUsCvAK4NIyCiWcdxNieTyVO2ckRkVXd39y/9/f2d+Xz+WxG5LIwDwDmt9XyVlFaBrW0VwfghrfUHY2Njq8bHx08BWN3Q0KDt1WuMsT3ks7CjIKIUM3NlBA4BeGQpAY7jvKGUesYmXyqV+kRE7i/gTzLzFpuMxpg9IvJmSBUcKlbOQgRSqdQ9vu9/uYThGWbusOXned5+AM+WYomol5kfs888z/sOwK1BXI7j3KuU+qosAqOjow2Tk5NTAC4PMDznuu7tvu/f7fv+wWoYItoXj8c/zGazthm1B/BcbGpqWtvW1maT/r8cKJTTyyLyfIQ8WDaEiF5h5n1FgrIba2RkZPX09PTZGvtBLWKmGhsb17e3t9tbc35VmwdsYtkEizSwRvVucwfAdmY+UpY71Qg8z3sRwAtRySPiXtJaW96yVXWXhTJ7S0TsRLziRUQHlFK7C1EIF1BEpFKph0XkneK9X6sS2zWJ6HGl1HtBtqHnbCeg2dnZ/UT0QNS8sDsVkU/j8fje4n2xbAEl0egQkR0AtgaN60RkZ71jRPSRUup0lIiFRqAaSeG7odlxnPlvQ9/3J4jovFLqQhSnoVVQK8lK8MuKwEocVtr+C2xgxTCw9jHoAAAAAElFTkSuQmCC");
// CONCATENATED MODULE: ./src/components/tabs/TabOperate.jsx
 // import "./style/index.scss";


var TabOperate = {
  name: 'TabOperate',
  props: {
    tabs: vue_types["a" /* default */].array,
    activeKey: vue_types["a" /* default */].string,
    image: {
      type: [String],
      default: function _default() {
        return menuClose;
      }
    }
  },
  methods: {
    handleMenuClick: function handleMenuClick(key) {
      // console.error('key', key);
      this.$emit('changeTab', key);
    },
    showCloseBtn: function showCloseBtn(item) {
      item.isShowClose = true;
      this.$forceUpdate();
    },
    hiddenCloseBtn: function hiddenCloseBtn(item) {
      item.isShowClose = false;
      this.$forceUpdate();
    },
    deleteTab: function deleteTab(item, event) {
      event.stopPropagation();
      this.$emit('deleteTab', item.key);
    },
    closeAllTabs: function closeAllTabs() {
      this.$emit('closeAllTabs');
    },
    closeOtherTabs: function closeOtherTabs() {
      this.$emit('closeOtherTabs');
    }
  },
  render: function render() {
    var h = arguments[0];
    var tabs = this.tabs,
        handleMenuClick = this.handleMenuClick,
        showCloseBtn = this.showCloseBtn,
        hiddenCloseBtn = this.hiddenCloseBtn,
        deleteTab = this.deleteTab,
        closeAllTabs = this.closeAllTabs,
        closeOtherTabs = this.closeOtherTabs;
    return h("div", {
      "class": "tabs-operate"
    }, [h("meg-dropdown", {
      attrs: {
        overlayClassName: 'tabs-operate-dropdown',
        trigger: ['hover']
      }
    }, [h("div", {
      "class": "operate-icon-area"
    }, [h("div", {
      "class": "operate-icon"
    })]), h("meg-menu", {
      slot: "overlay"
    }, [h("meg-menu-item-group", {
      key: "g1"
    }, [tabs.map(function (item) {
      return h("meg-menu-item", {
        key: item.key,
        on: {
          "click": function click() {
            return handleMenuClick(item.key);
          },
          "mouseover": function mouseover() {
            return showCloseBtn(item);
          },
          "mouseleave": function mouseleave() {
            return hiddenCloseBtn(item);
          }
        }
      }, [h("span", [item.tab]), h("span", {
        on: {
          "click": function click($event) {
            return deleteTab(item, $event);
          }
        },
        "class": "meg-tabs-menu-item-close-x"
      })]);
    })]), h("meg-menu-divider"), h("meg-menu-item", {
      on: {
        "click": closeAllTabs
      },
      "class": 'menu-close'
    }, [h("span", {
      "class": "meg-tabs-menu-item-close-x"
    }), h("span", ["\u5173\u95ED\u5168\u90E8"])]), h("meg-menu-item", {
      on: {
        "click": closeOtherTabs
      },
      "class": 'menu-close'
    }, [h("span", {
      "class": "meg-tabs-menu-item-close-x"
    }), h("span", ["\u5173\u95ED\u5176\u4ED6"])])])])]);
  }
};
/* harmony default export */ var tabs_TabOperate = (TabOperate);
// CONCATENATED MODULE: ./src/base/vc-tabs/src/ScrollableTabBarNode.jsx




function ScrollableTabBarNode_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ScrollableTabBarNode_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ScrollableTabBarNode_ownKeys(Object(source), true).forEach(function (key) { ScrollableTabBarNode_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ScrollableTabBarNode_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ScrollableTabBarNode_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function ScrollableTabBarNode_noop() {}

/* harmony default export */ var ScrollableTabBarNode = ({
  name: 'ScrollableTabBarNode',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    activeKey: vue_types["a" /* default */].any,
    getRef: vue_types["a" /* default */].func.def(function () {}),
    saveRef: vue_types["a" /* default */].func.def(function () {}),
    tabBarPosition: vue_types["a" /* default */].oneOf(['left', 'right', 'top', 'bottom']).def('left'),
    prefixCls: vue_types["a" /* default */].string.def(''),
    scrollAnimated: vue_types["a" /* default */].bool.def(true),
    navWrapper: vue_types["a" /* default */].func.def(function (arg) {
      return arg;
    }),
    prevIcon: vue_types["a" /* default */].any,
    nextIcon: vue_types["a" /* default */].any,
    direction: vue_types["a" /* default */].string,
    tabs: vue_types["a" /* default */].array,
    operateTab: vue_types["a" /* default */].bool.def(false),
    changeTabFunc: vue_types["a" /* default */].func,
    removeTabFunc: vue_types["a" /* default */].func,
    closeOtherTabFunc: vue_types["a" /* default */].func,
    closeAllTabFunc: vue_types["a" /* default */].func
  },
  data: function data() {
    this.offset = 0;
    this.prevProps = ScrollableTabBarNode_objectSpread({}, this.$props);
    return {
      next: false,
      prev: false
    };
  },
  watch: {
    tabBarPosition: function tabBarPosition() {
      var _this = this;

      this.tabBarPositionChange = true;
      this.$nextTick(function () {
        _this.setOffset(0);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.updatedCal();

      _this2.debouncedResize = debounce_default()(function () {
        _this2.setNextPrev();

        _this2.scrollToActiveTab();
      }, 200);
      _this2.resizeObserver = new ResizeObserver_es["a" /* default */](_this2.debouncedResize);

      _this2.resizeObserver.observe(_this2.$props.getRef('container'));
    });
  },
  updated: function updated() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.updatedCal(_this3.prevProps);

      _this3.prevProps = ScrollableTabBarNode_objectSpread({}, _this3.$props);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.debouncedResize && this.debouncedResize.cancel) {
      this.debouncedResize.cancel();
    }
  },
  methods: {
    updatedCal: function updatedCal(prevProps) {
      var _this4 = this;

      var props = this.$props;

      if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
        this.setOffset(0);
        return;
      } // wait next, prev show hide


      if (this.isNextPrevShown(this.$data) !== this.isNextPrevShown(this.setNextPrev())) {
        this.$forceUpdate();
        this.$nextTick(function () {
          _this4.scrollToActiveTab();
        });
      } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
        // can not use props.activeKey
        this.scrollToActiveTab();
      }
    },
    setNextPrev: function setNextPrev() {
      var navNode = this.$props.getRef('nav');
      var navTabsContainer = this.$props.getRef('navTabsContainer');
      var navNodeWH = this.getScrollWH(navTabsContainer || navNode); // Add 1px to fix `offsetWidth` with decimal in Chrome not correct handle
      // https://github.com/ant-design/ant-design/issues/13423

      var containerWH = this.getOffsetWH(this.$props.getRef('container')) + 1;
      var navWrapNodeWH = this.getOffsetWH(this.$props.getRef('navWrap'));
      var offset = this.offset;
      var minOffset = containerWH - navNodeWH;
      var next = this.next,
          prev = this.prev;

      if (minOffset >= 0) {
        next = false;
        this.setOffset(0, false);
        offset = 0;
      } else if (minOffset < offset) {
        next = true;
      } else {
        next = false; // Fix https://github.com/ant-design/ant-design/issues/8861
        // Test with container offset which is stable
        // and set the offset of the nav wrap node

        var realOffset = navWrapNodeWH - navNodeWH;
        this.setOffset(realOffset, false);
        offset = realOffset;
      }

      if (offset < 0) {
        prev = true;
      } else {
        prev = false;
      }

      this.setNext(next);
      this.setPrev(prev);
      return {
        next: next,
        prev: prev
      };
    },
    getOffsetWH: function getOffsetWH(node) {
      var tabBarPosition = this.$props.tabBarPosition;
      var prop = 'offsetWidth';

      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'offsetHeight';
      }

      return node[prop];
    },
    getScrollWH: function getScrollWH(node) {
      var tabBarPosition = this.tabBarPosition;
      var prop = 'scrollWidth';

      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'scrollHeight';
      }

      return node[prop];
    },
    getOffsetLT: function getOffsetLT(node) {
      var tabBarPosition = this.$props.tabBarPosition;
      var prop = 'left';

      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'top';
      }

      return node.getBoundingClientRect()[prop];
    },
    setOffset: function setOffset(offset) {
      var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var target = Math.min(0, offset);

      if (this.offset !== target) {
        this.offset = target;
        var navOffset = {};
        var tabBarPosition = this.$props.tabBarPosition;
        var navStyle = this.$props.getRef('nav').style;
        var transformSupported = isTransform3dSupported(navStyle);

        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
          if (transformSupported) {
            navOffset = {
              value: "translate3d(0,".concat(target, "px,0)")
            };
          } else {
            navOffset = {
              name: 'top',
              value: "".concat(target, "px")
            };
          }
        } else if (transformSupported) {
          if (this.$props.direction === 'rtl') {
            target = -target;
          }

          navOffset = {
            value: "translate3d(".concat(target, "px,0,0)")
          };
        } else {
          navOffset = {
            name: 'left',
            value: "".concat(target, "px")
          };
        }

        if (transformSupported) {
          setTransform(navStyle, navOffset.value);
        } else {
          navStyle[navOffset.name] = navOffset.value;
        }

        if (checkNextPrev) {
          this.setNextPrev();
        }
      }
    },
    setPrev: function setPrev(v) {
      if (this.prev !== v) {
        this.prev = v;
      }
    },
    setNext: function setNext(v) {
      if (!v) {// debugger
      }

      if (this.next !== v) {
        this.next = v;
      }
    },
    isNextPrevShown: function isNextPrevShown(state) {
      if (state) {
        return state.next || state.prev;
      }

      return this.next || this.prev;
    },
    prevTransitionEnd: function prevTransitionEnd(e) {
      if (e.propertyName !== 'opacity') {
        return;
      }

      var container = this.$props.getRef('container');
      this.scrollToActiveTab({
        target: container,
        currentTarget: container
      });
    },
    scrollToActiveTab: function scrollToActiveTab(e) {
      var activeTab = this.$props.getRef('activeTab');
      var navWrap = this.$props.getRef('navWrap');

      if (e && e.target !== e.currentTarget || !activeTab) {
        return;
      } // when not scrollable or enter scrollable first time, don't emit scrolling


      var needToSroll = this.isNextPrevShown() && this.lastNextPrevShown;
      this.lastNextPrevShown = this.isNextPrevShown();

      if (!needToSroll) {
        return;
      }

      var activeTabWH = this.getScrollWH(activeTab);
      var navWrapNodeWH = this.getOffsetWH(navWrap);
      var offset = this.offset;
      var wrapOffset = this.getOffsetLT(navWrap);
      var activeTabOffset = this.getOffsetLT(activeTab);

      if (wrapOffset > activeTabOffset) {
        offset += wrapOffset - activeTabOffset;
        this.setOffset(offset);
      } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
        offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
        this.setOffset(offset);
      }
    },
    prevClick: function prevClick(e) {
      this.__emit('prevClick', e);

      var navWrapNode = this.$props.getRef('navWrap');
      var navWrapNodeWH = this.getOffsetWH(navWrapNode);
      var offset = this.offset;
      this.setOffset(offset + navWrapNodeWH);
    },
    nextClick: function nextClick(e) {
      this.__emit('nextClick', e);

      var navWrapNode = this.$props.getRef('navWrap');
      var navWrapNodeWH = this.getOffsetWH(navWrapNode);
      var offset = this.offset;
      this.setOffset(offset - navWrapNodeWH);
    },
    handleChange: function handleChange(activeKey) {
      this.changeTabFunc && this.changeTabFunc(activeKey);
    },
    handleCloseOtherTabs: function handleCloseOtherTabs() {
      this.closeOtherTabFunc && this.closeOtherTabFunc();
    },
    handleCloseAllTabs: function handleCloseAllTabs() {
      this.closeAllTabFunc && this.closeAllTabFunc();
    },
    removeTab: function removeTab(targetKey) {
      this.removeTabFunc && this.removeTabFunc(targetKey, undefined);
    }
  },
  render: function render() {
    var _ref,
        _ref2,
        _navClasses,
        _ref3,
        _this5 = this;

    var h = arguments[0];
    var next = this.next,
        prev = this.prev;
    var _this$$props = this.$props,
        prefixCls = _this$$props.prefixCls,
        scrollAnimated = _this$$props.scrollAnimated,
        navWrapper = _this$$props.navWrapper,
        tabs = _this$$props.tabs,
        activeKey = _this$$props.activeKey,
        operateTab = _this$$props.operateTab;
    var prevIcon = Object(props_util["getComponentFromProp"])(this, 'prevIcon');
    var nextIcon = Object(props_util["getComponentFromProp"])(this, 'nextIcon');
    var showNextPrev = prev || next;
    var prevButton = h("span", {
      on: {
        "click": prev ? this.prevClick : ScrollableTabBarNode_noop,
        "transitionend": this.prevTransitionEnd
      },
      attrs: {
        unselectable: "unselectable"
      },
      "class": (_ref = {}, ScrollableTabBarNode_defineProperty(_ref, "".concat(prefixCls, "-tab-prev"), 1), ScrollableTabBarNode_defineProperty(_ref, "".concat(prefixCls, "-tab-btn-disabled"), !prev), ScrollableTabBarNode_defineProperty(_ref, "".concat(prefixCls, "-tab-arrow-show"), showNextPrev), _ref)
    }, [prevIcon || h("span", {
      "class": "".concat(prefixCls, "-tab-prev-icon")
    })]);
    var nextButton = h("span", {
      on: {
        "click": next ? this.nextClick : ScrollableTabBarNode_noop
      },
      attrs: {
        unselectable: "unselectable"
      },
      "class": (_ref2 = {}, ScrollableTabBarNode_defineProperty(_ref2, "".concat(prefixCls, "-tab-next"), 1), ScrollableTabBarNode_defineProperty(_ref2, "".concat(prefixCls, "-tab-btn-disabled"), !next), ScrollableTabBarNode_defineProperty(_ref2, "".concat(prefixCls, "-tab-arrow-show"), showNextPrev), _ref2)
    }, [nextIcon || h("span", {
      "class": "".concat(prefixCls, "-tab-next-icon")
    })]);
    var navClassName = "".concat(prefixCls, "-nav");
    var navClasses = (_navClasses = {}, ScrollableTabBarNode_defineProperty(_navClasses, navClassName, true), ScrollableTabBarNode_defineProperty(_navClasses, scrollAnimated ? "".concat(navClassName, "-animated") : "".concat(navClassName, "-no-animated"), true), _navClasses);
    return h("div", babel_helper_vue_jsx_merge_props_default()([{
      "class": (_ref3 = {}, ScrollableTabBarNode_defineProperty(_ref3, "".concat(prefixCls, "-nav-container"), 1), ScrollableTabBarNode_defineProperty(_ref3, "".concat(prefixCls, "-nav-container-scrolling"), showNextPrev), ScrollableTabBarNode_defineProperty(_ref3, "".concat(prefixCls, "-nav-container-operate"), operateTab), _ref3),
      key: "container"
    }, {
      directives: [{
        name: 'meg-ref',
        value: this.saveRef('container')
      }]
    }]), [prevButton, nextButton, h("div", babel_helper_vue_jsx_merge_props_default()([{
      "class": "".concat(prefixCls, "-nav-wrap")
    }, {
      directives: [{
        name: 'meg-ref',
        value: this.saveRef('navWrap')
      }]
    }]), [h("div", {
      "class": "".concat(prefixCls, "-nav-scroll")
    }, [h("div", babel_helper_vue_jsx_merge_props_default()([{
      "class": navClasses
    }, {
      directives: [{
        name: 'meg-ref',
        value: this.saveRef('nav')
      }]
    }]), [navWrapper(this.$slots.default)])])]), operateTab && h(tabs_TabOperate, {
      attrs: {
        tabs: tabs,
        activeKey: activeKey
      },
      on: {
        "changeTab": function changeTab(val) {
          return _this5.handleChange(val);
        },
        "deleteTab": function deleteTab(val) {
          return _this5.removeTab(val, undefined);
        },
        "closeOtherTabs": function closeOtherTabs() {
          return _this5.handleCloseOtherTabs();
        },
        "closeAllTabs": function closeAllTabs() {
          return _this5.handleCloseAllTabs();
        }
      }
    })]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-tabs/src/SaveRef.jsx

/* harmony default export */ var SaveRef = ({
  props: {
    children: vue_types["a" /* default */].func.def(function () {
      return null;
    })
  },
  methods: {
    getRef: function getRef(name) {
      return this[name];
    },
    saveRef: function saveRef(name) {
      var _this = this;

      return function (node) {
        if (node) {
          _this[name] = node;
        }
      };
    }
  },
  render: function render() {
    var _this2 = this;

    // 每次都new一个新的function，避免子节点不能重新渲染
    var saveRef = function saveRef(name) {
      return _this2.saveRef(name);
    };

    var getRef = function getRef(name) {
      return _this2.getRef(name);
    };

    return this.children(saveRef, getRef);
  }
});
// CONCATENATED MODULE: ./src/base/vc-tabs/src/ScrollableInkTabBar.jsx





function ScrollableInkTabBar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ScrollableInkTabBar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ScrollableInkTabBar_ownKeys(Object(source), true).forEach(function (key) { ScrollableInkTabBar_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ScrollableInkTabBar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ScrollableInkTabBar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/* harmony default export */ var ScrollableInkTabBar = ({
  name: 'ScrollableInkTabBar',
  inheritAttrs: false,
  props: ['extraContent', 'inkBarAnimated', 'tabBarGutter', 'prefixCls', 'navWrapper', 'tabBarPosition', 'panels', 'activeKey', 'prevIcon', 'nextIcon', 'tabs', 'operateTab', 'changeTabFunc', 'removeTabFunc', 'closeAllTabFunc', 'closeOtherTabFunc'],
  render: function render() {
    var h = arguments[0];

    var props = ScrollableInkTabBar_objectSpread({}, this.$props);

    var listeners = Object(props_util["getListeners"])(this);
    var renderTabBarNode = this.$scopedSlots.default;
    return h(SaveRef, {
      attrs: {
        children: function children(saveRef, getRef) {
          return h(TabBarRootNode, babel_helper_vue_jsx_merge_props_default()([{
            attrs: {
              saveRef: saveRef
            }
          }, {
            props: props,
            on: listeners
          }]), [h(ScrollableTabBarNode, babel_helper_vue_jsx_merge_props_default()([{
            attrs: {
              saveRef: saveRef,
              getRef: getRef
            }
          }, {
            props: props,
            on: listeners
          }]), [h(TabBarTabsNode, babel_helper_vue_jsx_merge_props_default()([{
            attrs: {
              saveRef: saveRef
            }
          }, {
            props: ScrollableInkTabBar_objectSpread(ScrollableInkTabBar_objectSpread({}, props), {}, {
              renderTabBarNode: renderTabBarNode
            }),
            on: listeners
          }])), h(InkTabBarNode, babel_helper_vue_jsx_merge_props_default()([{
            attrs: {
              saveRef: saveRef,
              getRef: getRef
            }
          }, {
            props: props,
            on: listeners
          }]))])]);
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./src/components/tabs/TabBar.jsx
function TabBar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TabBar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TabBar_ownKeys(Object(source), true).forEach(function (key) { TabBar_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TabBar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function TabBar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





var TabBar = {
  name: "TabBar",
  inheritAttrs: false,
  props: {
    prefixCls: vue_types["a" /* default */].string,
    tabBarStyle: vue_types["a" /* default */].object,
    tabBarExtraContent: vue_types["a" /* default */].any,
    type: vue_types["a" /* default */].oneOf(["line", "card", "editable-card"]),
    tabPosition: vue_types["a" /* default */].oneOf(["top", "right", "bottom", "left"]).def("top"),
    tabBarPosition: vue_types["a" /* default */].oneOf(["top", "right", "bottom", "left"]),
    size: vue_types["a" /* default */].oneOf(["default", "small", "large"]),
    animated: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].bool, vue_types["a" /* default */].object]),
    renderTabBar: vue_types["a" /* default */].func,
    panels: vue_types["a" /* default */].array.def([]),
    activeKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    tabBarGutter: vue_types["a" /* default */].number,
    operateTab: vue_types["a" /* default */].bool.def(false),
    tabs: vue_types["a" /* default */].array,
    changeTabFunc: vue_types["a" /* default */].func,
    removeTabFunc: vue_types["a" /* default */].func,
    closeAllTabFunc: vue_types["a" /* default */].func,
    closeOtherTabFunc: vue_types["a" /* default */].func
  },
  render: function render() {
    var _cls;

    var h = arguments[0];
    var _this$$props = this.$props,
        tabBarStyle = _this$$props.tabBarStyle,
        _this$$props$animated = _this$$props.animated,
        animated = _this$$props$animated === void 0 ? true : _this$$props$animated,
        renderTabBar = _this$$props.renderTabBar,
        tabBarExtraContent = _this$$props.tabBarExtraContent,
        tabPosition = _this$$props.tabPosition,
        prefixCls = _this$$props.prefixCls,
        _this$$props$type = _this$$props.type,
        type = _this$$props$type === void 0 ? "line" : _this$$props$type,
        size = _this$$props.size,
        operateTab = _this$$props.operateTab;
    var inkBarAnimated = _typeof(animated) === "object" ? animated.inkBar : animated;
    var isVertical = tabPosition === "left" || tabPosition === "right";
    var prevIcon = !operateTab ? h("span", {
      "class": "".concat(prefixCls, "-tab-prev-icon")
    }, [isVertical ? h("meg-icon", {
      attrs: {
        name: "megui-up"
      },
      "class": "".concat(prefixCls, "-tab-prev-icon-target")
    }) : h("meg-icon", {
      attrs: {
        name: "megui-left"
      },
      "class": "".concat(prefixCls, "-tab-prev-icon-target")
    })]) : null;
    var nextIcon = !operateTab ? h("span", {
      "class": "".concat(prefixCls, "-tab-next-icon")
    }, [isVertical ? h("meg-icon", {
      "class": "".concat(prefixCls, "-tab-next-icon-target"),
      attrs: {
        name: "megui-dropdown"
      }
    }) : h("meg-icon", {
      attrs: {
        name: "megui-right"
      },
      "class": "".concat(prefixCls, "-tab-next-icon-target")
    })]) : null; // Additional className for style usage

    var cls = (_cls = {}, TabBar_defineProperty(_cls, "".concat(prefixCls, "-").concat(tabPosition, "-bar"), true), TabBar_defineProperty(_cls, "".concat(prefixCls, "-").concat(size, "-bar"), !!size), TabBar_defineProperty(_cls, "".concat(prefixCls, "-card-bar"), type && type.indexOf("card") >= 0), TabBar_defineProperty(_cls, "".concat(prefixCls, "-opearate-bar"), operateTab), _cls);
    var renderProps = {
      props: TabBar_objectSpread(TabBar_objectSpread(TabBar_objectSpread({}, this.$props), this.$attrs), {}, {
        inkBarAnimated: inkBarAnimated,
        extraContent: tabBarExtraContent,
        prevIcon: prevIcon,
        nextIcon: nextIcon
      }),
      style: tabBarStyle,
      on: Object(props_util["getListeners"])(this),
      class: cls
    };
    var RenderTabBar;

    if (renderTabBar) {
      RenderTabBar = renderTabBar(renderProps, ScrollableInkTabBar); // https://github.com/vueComponent/ant-design-vue/issues/2157

      return Object(vnode["a" /* cloneElement */])(RenderTabBar, renderProps);
    } else {
      return h(ScrollableInkTabBar, renderProps);
    }
  }
};
/* harmony default export */ var tabs_TabBar = (TabBar);
// CONCATENATED MODULE: ./src/components/tabs/index.jsx


function tabs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function tabs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tabs_ownKeys(Object(source), true).forEach(function (key) { tabs_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tabs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function tabs_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function tabs_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { tabs_typeof = function _typeof(obj) { return typeof obj; }; } else { tabs_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return tabs_typeof(obj); }










 // import "./style/index.scss";

var tabs_Tabs = {
  TabPane: TabPane,
  name: "MegTabs",
  model: {
    prop: "activeKey",
    event: "change"
  },
  props: {
    prefixCls: vue_types["a" /* default */].string,
    activeKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    defaultActiveKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    hideAdd: vue_types["a" /* default */].bool.def(false),
    tabBarStyle: vue_types["a" /* default */].object,
    tabBarExtraContent: vue_types["a" /* default */].any,
    destroyInactiveTabPane: vue_types["a" /* default */].bool.def(false),
    type: vue_types["a" /* default */].oneOf(["line", "card", "editable-card"]),
    tabPosition: vue_types["a" /* default */].oneOf(["top", "right", "bottom", "left"]).def("top"),
    size: vue_types["a" /* default */].oneOf(["default", "small", "large"]),
    animated: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].bool, vue_types["a" /* default */].object]),
    tabBarGutter: vue_types["a" /* default */].number,
    renderTabBar: vue_types["a" /* default */].func,
    operateTab: vue_types["a" /* default */].bool.def(false)
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  mounted: function mounted() {
    var NO_FLEX = " no-flex";
    var tabNode = this.$el;

    if (tabNode && !isFlexSupported && tabNode.className.indexOf(NO_FLEX) === -1) {
      tabNode.className += NO_FLEX;
    }
  },
  methods: {
    removeTab: function removeTab(targetKey, e) {
      e === null || e === void 0 ? void 0 : e.stopPropagation();

      if (Object(isvalid["a" /* default */])(targetKey)) {
        this.$emit("edit", targetKey, "remove");
      }
    },
    handleChange: function handleChange(activeKey) {
      this.$emit("change", activeKey);
    },
    createNewTab: function createNewTab(targetKey) {
      this.$emit("edit", targetKey, "add");
    },
    onTabClick: function onTabClick(val) {
      this.$emit("tabClick", val);
    },
    onPrevClick: function onPrevClick(val) {
      this.$emit("prevClick", val);
    },
    onNextClick: function onNextClick(val) {
      this.$emit("nextClick", val);
    },
    handleCloseOtherTabs: function handleCloseOtherTabs() {
      this.$emit("closeOtherTabs", this.activeKey);
    },
    handleCloseAllTabs: function handleCloseAllTabs() {
      this.$emit("closeAllTabs");
    }
  },
  render: function render() {
    var _cls,
        _this = this,
        _contentCls;

    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var customizePrefixCls = props.prefixCls,
        size = props.size,
        _props$type = props.type,
        type = _props$type === void 0 ? "line" : _props$type,
        tabPosition = props.tabPosition,
        _props$animated = props.animated,
        animated = _props$animated === void 0 ? true : _props$animated,
        hideAdd = props.hideAdd,
        renderTabBar = props.renderTabBar,
        operateTab = props.operateTab;
    var activeKey = this.activeKey,
        handleChange = this.handleChange,
        removeTab = this.removeTab,
        handleCloseAllTabs = this.handleCloseAllTabs,
        handleCloseOtherTabs = this.handleCloseOtherTabs;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls("tabs", customizePrefixCls);
    var children = Object(props_util["filterEmpty"])(this.$slots.default);
    var tabBarExtraContent = Object(props_util["getComponentFromProp"])(this, "tabBarExtraContent");
    var tabPaneAnimated = tabs_typeof(animated) === "object" ? animated.tabPane : animated; // card tabs should not have animation

    if (type !== "line") {
      tabPaneAnimated = "animated" in props ? tabPaneAnimated : false;
    }

    var cls = (_cls = {}, tabs_defineProperty(_cls, "".concat(prefixCls, "-vertical"), tabPosition === "left" || tabPosition === "right"), tabs_defineProperty(_cls, "".concat(prefixCls, "-").concat(size), !!size), tabs_defineProperty(_cls, "".concat(prefixCls, "-card"), type.indexOf("card") >= 0), tabs_defineProperty(_cls, "".concat(prefixCls, "-").concat(type), true), tabs_defineProperty(_cls, "".concat(prefixCls, "-no-animation"), !tabPaneAnimated), _cls); // only card type tabs can be added and closed

    var childrenWithClose = [];
    var tabsInfoArr = [];

    if (type === "editable-card") {
      childrenWithClose = [];
      children.forEach(function (child, index) {
        var props = Object(props_util["getOptionProps"])(child);
        var closable = props.closable;
        closable = typeof closable === "undefined" ? true : closable;
        var closeIcon = closable ? h("meg-icon", {
          "class": "".concat(prefixCls, "-close-x"),
          attrs: {
            name: "megui-close"
          },
          on: {
            "click": function click(e) {
              return _this.removeTab(child.key, e);
            }
          }
        }) : null;
        childrenWithClose.push(Object(vnode["a" /* cloneElement */])(child, {
          props: {
            tab: h("div", {
              "class": closable ? undefined : "".concat(prefixCls, "-tab-unclosable")
            }, [Object(props_util["getComponentFromProp"])(child, "tab"), closeIcon])
          },
          key: child.key || index
        }));
      }); // Add new tab handler

      if (!hideAdd) {
        tabBarExtraContent = h("span", {
          on: {
            "click": this.createNewTab
          }
        }, [h("meg-icon", {
          attrs: {
            name: "megui-add",
            original: true,
            width: "16px",
            height: "16px"
          },
          "class": "".concat(prefixCls, "-new-tab")
        }), tabBarExtraContent]);
      }
    }

    if (type === "editable-card" && operateTab && tabPosition === 'top') {
      childrenWithClose = [];
      tabsInfoArr = [];
      children.forEach(function (child, index) {
        var props = Object(props_util["getOptionProps"])(child);
        tabsInfoArr.push({
          tab: props.tab,
          key: child.key,
          isShowClose: false
        });
        var closable = props.closable;
        closable = typeof closable === "undefined" ? true : closable; // const closeIcon = closable ? (
        //     <meg-icon
        //         class={`${prefixCls}-close-x`}
        //         name="megui-close"
        //         onClick={e => this.removeTab(child.key, e)}
        //     />
        // ) : null;

        var closeIcon = closable ? h("span", {
          "class": "operate-tab-close",
          on: {
            "click": function click(e) {
              return _this.removeTab(child.key, e);
            }
          }
        }) : null;
        childrenWithClose.push(Object(vnode["a" /* cloneElement */])(child, {
          props: {
            tab: h("div", {
              "class": closable ? "".concat(prefixCls, "-tab-closable") : "".concat(prefixCls, "-tab-unclosable")
            }, [Object(props_util["getComponentFromProp"])(child, "tab"), closeIcon])
          },
          key: child.key || index
        }));
      });
      tabBarExtraContent = null;
    }

    tabBarExtraContent = tabBarExtraContent ? h("div", {
      "class": "".concat(prefixCls, "-extra-content")
    }, [tabBarExtraContent]) : null;
    var renderTabBarSlot = renderTabBar || this.$scopedSlots.renderTabBar;
    var listeners = Object(props_util["getListeners"])(this);
    var tabBarProps = {
      props: tabs_objectSpread(tabs_objectSpread({}, this.$props), {}, {
        prefixCls: prefixCls,
        tabBarExtraContent: tabBarExtraContent,
        renderTabBar: renderTabBarSlot,
        tabs: tabsInfoArr,
        changeTabFunc: handleChange,
        removeTabFunc: removeTab,
        closeAllTabFunc: handleCloseAllTabs,
        closeOtherTabFunc: handleCloseOtherTabs
      }),
      on: listeners
    };
    var contentCls = (_contentCls = {}, tabs_defineProperty(_contentCls, "".concat(prefixCls, "-").concat(tabPosition, "-content"), true), tabs_defineProperty(_contentCls, "".concat(prefixCls, "-card-content"), type.indexOf("card") >= 0), _contentCls);
    var tabsProps = {
      props: tabs_objectSpread(tabs_objectSpread({}, Object(props_util["getOptionProps"])(this)), {}, {
        prefixCls: prefixCls,
        tabBarPosition: tabPosition,
        // https://github.com/vueComponent/ant-design-vue/issues/2030
        // 如仅传递 tabBarProps 会导致，第二次执行 renderTabBar 时，丢失 on 属性，
        // 添加key之后，会在babel jsx 插件中做一次merge，最终TabBar接收的是一个新的对象，而不是 tabBarProps
        renderTabBar: function renderTabBar() {
          return h(tabs_TabBar, babel_helper_vue_jsx_merge_props_default()([{
            key: "tabBar"
          }, tabBarProps]));
        },
        renderTabContent: function renderTabContent() {
          return h(TabContent, {
            "class": contentCls,
            attrs: {
              animated: tabPaneAnimated,
              animatedWithMargin: true
            }
          });
        },
        children: childrenWithClose.length > 0 ? childrenWithClose : children,
        __propsSymbol__: Symbol()
      }),
      on: tabs_objectSpread(tabs_objectSpread({}, listeners), {}, {
        change: this.handleChange
      }),
      class: cls
    };
    return h(src, tabsProps);
  }
};
tabs_Tabs.TabPane = tabs_objectSpread(tabs_objectSpread({}, TabPane), {}, {
  name: "MegTabPane",
  __ANT_TAB_PANE: true
});
tabs_Tabs.TabContent = tabs_objectSpread(tabs_objectSpread({}, TabContent), {}, {
  name: "MegTabContent"
});

tabs_Tabs.install = function (Vue) {
  Vue.component(tabs_Tabs.name, tabs_Tabs);
  Vue.component(tabs_Tabs.TabPane.name, tabs_Tabs.TabPane);
  Vue.component(tabs_Tabs.TabContent.name, tabs_Tabs.TabContent);
};

/* harmony default export */ var components_tabs = __webpack_exports__["default"] = (tabs_Tabs);


/***/ })

}]);